import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ProductResponse,
  ZentraComponent,
} from '../interfaces/subProduct.interface';
import { BackendAccessService } from './APICalls/backend-access-service';
import { AuthService } from './Auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SubProductsService {
  ONE_TIME_PRODUCT_IDS = new Set<number>([7024655, 7025905, 7029069]);

  constructor(
    private readonly backend: BackendAccessService,
    private readonly authService: AuthService
  ) {}

  /* istanbul ignore next */
  getZentraProducts(): Observable<ProductResponse[]> {
    return this.backend.getSubProductsWithKeyword('Zentra');
  }
  /* istanbul ignore next */
  getZentraComponents(): Observable<ZentraComponent[]> {
    return this.backend.getSubComponentsWithKeyword('Zentra');
  }

  /* istanbul ignore next */
  getZentraProductsIntegrator(): Observable<ProductResponse[]> {
    return this.backend.getSubProductsWithKeywordIntegrator('ZentraIntegrator');
  }
  /* istanbul ignore next */
  getZentraComponentsIntegrator(): Observable<ZentraComponent[]> {
    return this.backend.getSubComponentsWithKeywordIntegrator(
      'ZentraIntegrator'
    );
  }

  /* istanbul ignore next */
  getZentraProductsGuestPurchaser(): Observable<ProductResponse[]> {
    return this.backend.getSubProductsWithKeywordGuestPurchaser(
      'GuestPurchaser'
    );
  }
  /* istanbul ignore next */
  getZentraComponentsGuestPurchaser(): Observable<ZentraComponent[]> {
    return this.backend.getSubComponentsWithKeywordGuestPurchaser(
      'GuestPurchaser'
    );
  }
  /* istanbul ignore next */
  getSATProducts(): Observable<ProductResponse[]> {
    return this.backend.getSubProductsWithKeyword('Stanley');
  }

  /* istanbul ignore next */
  getSATComponents(): Observable<ZentraComponent[]> {
    return this.backend.getSubComponentsWithKeyword('Stanley');
  }

  /* istanbul ignore next */
  isOneTimeProductId(value: unknown): boolean {
    if (value === undefined || value === null) return false;
    const idNum = Number(value);
    if (Number.isNaN(idNum)) return false;
    return this.ONE_TIME_PRODUCT_IDS.has(idNum);
  }

  /* istanbul ignore next */
  productHasExistingSiteVariants(productId: number): boolean {
    return this.authService
      .getComponentEntries(productId)
      .some((e) => e.isExistingZentraConnectSite !== null);
  }

  /* istanbul ignore next */
  // Convenience: inspect common subscription shapes and determine if it's one-time
  isOneTimeForSubscription(subscriptionLike: any): boolean {
    if (!subscriptionLike) return false;

    const candidates = [
      subscriptionLike?.subscription?.product?.id,
      subscriptionLike?.subscription?.product?.product_id,
      subscriptionLike?.subscription?.product_id,
      subscriptionLike?.subscriptionData?.product_id,
      subscriptionLike?.maxioProductId,
      subscriptionLike?.product_id,
      subscriptionLike?.product?.id,
    ];

    for (const candidate of candidates) {
      if (candidate !== undefined && candidate !== null) {
        if (this.isOneTimeProductId(candidate)) return true;
      }
    }
    return false;
  }
}
